import Tooltip from '@mui/material/Tooltip';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import React from 'react';

dayjs.extend(relativeTime, LocalizedFormat); // use plugin

const CreationTime = ({ createdAt }) => {
  let created;
  if (!createdAt) created = dayjs();
  else created = dayjs(createdAt);

  return (
    <>
      <Tooltip title={created.format('MMMM DD YYYY H:mm')} placement="bottom">
        <span>
          {created.isBefore(dayjs().startOf('month').add(-1, 'month'))
            ? created.format('MMMM YYYY')
            : created.fromNow()}
        </span>
      </Tooltip>
    </>
  );
};

export default CreationTime;
